import { render, staticRenderFns } from "./CreatePo.vue?vue&type=template&id=36b0eb0a&"
import script from "./CreatePo.vue?vue&type=script&lang=js&"
export * from "./CreatePo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports